module.exports = __webpack_public_path__ + "static/CocoaButter-7fef82966d71740f809ff6da4e52b6c9.webp";